<template>
  <div
    class="mx-auto flex h-full min-h-0 w-full max-w-2xl flex-col px-3 md:mt-10 md:px-4 lg:h-auto"
  >
    <WysiwygTextField
      class="min-h-0"
      :model-value="modelValue"
      :autofocus="autoFocusEnabled"
      :is-always-expanded="true"
      :compact="true"
      :placeholder="$t('common.answer')"
      @update:model-value="handleAnswer"
    />
  </div>
</template>

<script setup lang="ts">
  import WysiwygTextField from '@/core/components/base/wysiwyg/WysiwygTextField.vue'
  import type { JSONContent } from '@tiptap/vue-3'

  const emit = defineEmits<{
    (e: 'update:modelValue', value: JSONContent | undefined): void
  }>()

  interface Props {
    autoFocusEnabled: boolean
    modelValue: JSONContent | undefined
  }
  defineProps<Props>()

  const handleAnswer = (answer: JSONContent | undefined) => {
    emit('update:modelValue', answer)
  }
</script>
